import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/** The list tables whose "Rows per page" is remembered. */
export type PagedTable = "shipments" | "quotes" | "invoices";

/**
 * Rows per page, one per table and persisted.
 *
 * Per table, unlike the table/card view: someone who reads fifty invoices
 * at a time does not necessarily want fifty shipments. Kept in its own
 * slice so none of the page slices has to carry it.
 */
type PageSizeState = Record<PagedTable, number>;

const initialState: PageSizeState = {
	shipments: 10,
	quotes: 10,
	invoices: 10,
};

const pageSizeSlice = createSlice({
	name: "pageSize",
	initialState,
	reducers: {
		setPageSize: (
			state,
			action: PayloadAction<{ table: PagedTable; size: number }>,
		) => {
			state[action.payload.table] = action.payload.size;
		},
	},
});

export const { setPageSize } = pageSizeSlice.actions;
export default pageSizeSlice.reducer;
